import { render, staticRenderFns } from "./TransferredTaxcardEntry.vue?vue&type=template&id=4d433260&scoped=true&"
import script from "./TransferredTaxcardEntry.vue?vue&type=script&lang=ts&"
export * from "./TransferredTaxcardEntry.vue?vue&type=script&lang=ts&"
import style0 from "./TransferredTaxcardEntry.vue?vue&type=style&index=0&id=4d433260&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d433260",
  null
  
)

export default component.exports